import sidebar from '@/config/sidebars/admin_compare_providers'
import createVueApp from '@/common/create_app'

Styxie.Initializers.AdminCompareProvidersScanSessions = {
  index: async(props) => {
    const { default: Page } = await import('@/vue_widgets/admin/compare_providers/scan_sessions/index/index.vue')
    createVueApp(Page, { props, sidebar })
  },
  new: async(props) => {
    const { default: Page } = await import('@/vue_widgets/admin/compare_providers/scan_sessions/new/index.vue')
    createVueApp(Page, { props, sidebar })
  },
  show: async(props) => {
    const { default: Page } = await import('@/vue_widgets/admin/compare_providers/scan_sessions/show/index.vue')
    createVueApp(Page, { props, sidebar })
  }
}

Styxie.Initializers.AdminCompareProvidersProviderAccounts = {
  index: async(props) => {
    const { default: Page } = await import('@/vue_widgets/admin/compare_providers/provider_accounts/index/index.vue')
    createVueApp(Page, { props, sidebar })
  },
  edit: async(props) => {
    const { default: Page } = await import('@/vue_widgets/admin/compare_providers/provider_accounts/edit/index.vue')
    createVueApp(Page, { props, sidebar })
  }
}

Styxie.Initializers.AdminCompareProvidersCalibrations = {
  index: async(props) => {
    const { default: Page } = await import('@/vue_widgets/admin/compare_providers/calibrations/index/index.vue')
    createVueApp(Page, { props, sidebar })
  },
  new: async(props) => {
    const { default: Page } = await import('@/vue_widgets/admin/compare_providers/calibrations/form/index.vue')
    createVueApp(Page, { props, sidebar })
  },
  edit: async(props) => {
    const { default: Page } = await import('@/vue_widgets/admin/compare_providers/calibrations/form/index.vue')
    createVueApp(Page, { props, sidebar })
  }
}
